import React from 'react'
import { useSelector } from 'react-redux'
import ConfirmationPopupContent from 'src/components/ConfirmationPopupContent/ConfirmationPopupContent'
import Popup from 'src/components/Popup/Popup'
import Trns from 'src/localization/Trns'
import { usePutOrgPhysicalClearingsEnabled } from 'src/queries/organizations/physicalClearings.queries'
import { selectAppName } from 'src/redux/selectors/session.selectors'

interface DisconnectBankFeedPopupProps {
  organizationId: string
  closePopup: () => void
}
const DisconnectBankFeedPopup: React.FC<DisconnectBankFeedPopupProps> = (
  props,
) => {
  const appName = useSelector(selectAppName)
  const {
    mutate: putOrgPhysicalClearingsEnabled,
    isPending: putOrgPhysicalClearingsEnabledLoading,
    isSuccess: disconnectSuccess,
  } = usePutOrgPhysicalClearingsEnabled(props.organizationId)

  if (disconnectSuccess) {
    props.closePopup()
  }

  return (
    <Popup onClose={props.closePopup}>
      <ConfirmationPopupContent
        title={<Trns source={'Disconnect Bank Feed'} />}
        subtitle={
          <Trns
            source={
              'If you choose to disable the bank data feed, future physical card transactions will no longer display in ${brandName}. You can re-enable the data feed at any time.'
            }
            expressions={{
              brandName: appName,
            }}
          />
        }
        actionButtonLabel={<Trns source={'Confirm Disconnect'} />}
        actionButtonLoading={putOrgPhysicalClearingsEnabledLoading}
        actionButtonOnClick={(): void => {
          putOrgPhysicalClearingsEnabled({
            id: props.organizationId,
            body: {
              enabled: false,
            },
          })
        }}
        cancelButtonLabel={<Trns source={'Cancel'} />}
        cancelButtonOnClick={props.closePopup}
      />
    </Popup>
  )
}

export default DisconnectBankFeedPopup
